import { Locales, LocaleMessages, ServerConfig } from 'shared-types';

interface Params {
  language?: Locales;
  messages: LocaleMessages;
  serverConfig: ServerConfig<'admin'>;
}

const getExcelLearningPathsColumnOptions = ({
  language,
  messages,
  serverConfig
}: Params) => {
  const customAttributeOptions: { [key: string]: string } = {};

  serverConfig.pathCustomAttributes
    ?.filter((attr) => attr.displayInAnalytics)
    .forEach((attr) => {
      customAttributeOptions[`product.customAttributes.${attr.key}`] =
        attr.titleData?.[language || serverConfig.defaultSystemLanguage] ||
        attr.title;
    });

  return {
    'product.title': messages.commonPath,
    'product.categories': messages.commonCategories,
    'product.steps': messages.pathsSteps,
    'product.user.status': messages.commonStatus,
    'product.user.stepsStarted': messages.commonStarted,
    'product.user.stepsCompleted': messages.commonCompleted,
    'product.user.completedSteps': messages.excelStepsCompleted,
    'product.user.completionDate': messages.excelCompletionDate,
    ...customAttributeOptions
  };
};

export default getExcelLearningPathsColumnOptions;
